import React, { forwardRef } from 'react';
import './Post.css';
import { Avatar, Button } from '@material-ui/core';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import RepeatIcon from '@material-ui/icons/Repeat';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import PublishIcon from '@material-ui/icons/Publish';

import db from './firebase';

const Post = forwardRef(
  (
    { displayName, username, verified, text, image, avatar, liked, postId },
    ref
  ) => {
    const likePost = e => {
      let id =
        e.target.parentElement.parentElement.parentElement.parentElement.id ||
        e.target.parentElement.parentElement.parentElement.id;
      console.log(id);
      db.collection('posts')
        .doc(id)
        .update({ liked: !liked })
        .then(function () {
          console.log('Document successfully updated!');
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error);
        });
    };

    const deletePost = e => {
      e.preventDefault();
      let id =
        e.target.parentElement.parentElement.id || e.target.parentElement.id;

      db.collection('posts')
        .doc(id)
        .delete()
        .then(function () {
          console.log('Document successfully deleted!');
        })
        .catch(function (error) {
          console.error('Error removing document', error);
        });
    };

    return (
      <div className='post' ref={ref} id={postId}>
        <Button type='button' onClick={deletePost}>
          Delete
        </Button>
        <div className='post__avatar'>
          <Avatar src={avatar} />
        </div>
        <div className='post__body'>
          <div className='post__header'>
            <div className='post__headerText'>
              <h3>
                {displayName}{' '}
                <span className='post__headerSpecial'>
                  {verified && <VerifiedUserIcon className='post__badge' />}
                  {username}
                </span>
              </h3>
            </div>
            <div className='post__headerDescription'>
              <p>{text}</p>
            </div>
          </div>
          <img src={image} alt='' />
          <div className='post__footer'>
            <ChatBubbleOutlineIcon fontSize='small' />
            <RepeatIcon fontSize='small' />
            {liked ? (
              <FavoriteIcon
                className='post__favoriteIcon post__favoriteIcon--on'
                fontSize='small'
                onClick={likePost}
              />
            ) : (
              <FavoriteBorderIcon
                className='post__favoriteIcon post__favoriteIcon--off'
                fontSize='small'
                onClick={likePost}
              />
            )}
            <PublishIcon fontSize='small' />
          </div>
        </div>
      </div>
    );
  }
);

export default Post;
